import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "webapp/components";
import { FooterNavigation } from "webapp/components";
import { Header } from "webapp/components";
import { PaginationHelper } from "webapp/components";
import { TitleBar } from "webapp/components";
import { ATTMemberInformationForm } from "webapp/components/Partner/ATT/ATTMemberInformationForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";
export default function ATTMemberInformation(props) {
  const { t } = useTranslation();
  const [showFooter, setShowFooter] = useState(false);
  const [accountRef, setAccountRef] = useState(null);
  const [contactRef, setContactRef] = useState(null);
  const [isSelectedAccount, setIsSelectedAccount] = useState(false);
  const [showSelectUserModal, setShowSelectUserModal] = useState(false);
  const [autoSearchRequired, setAutoSearchRequired] = useState(props.currState.autoSearchRequired);
  const [skipMemberSearchLimit, setSkipMemberSearchLimit] = useState(props.currState.skipMemberSearchLimit);

  const [memberInfo, setMemberInfo] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("description.PolicyInformationVerifyHeader2")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onUserNext = () => {
    if (memberInfo && selectedContact) {
      props.context.setState(
        {
          accountRef: memberInfo.accountRef,
          contactRef: selectedContact.contactRef,
          allowVehicleInfoEdits: true,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.onUserNext === "function") {
            props.onUserNext();
          }
          props.context.saveWebAppState(props.context);
        },
      );
    } else if (props.currState.accountRef && props.currState.contactRef && skipMemberSearchLimit === 0) {
      props.context.setState(
        {
          // accountRef: props.context.accountRef,
          // contactRef: props.context.contactRef,
          skipMemberSearchLimit: skipMemberSearchLimit,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.onUserNext === "function") {
            props.onUserNext();
          }
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */
      setShowSelectUserModal(true);
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };
  const onContractLookupComplete = (success) => {
    devLog("success", success);
    if (autoSearchRequired && skipMemberSearchLimit < 2) {
      props.context.setState({
        skipMemberSearchLimit: skipMemberSearchLimit + 1,
      });
    }
    setShowFooter(!!success);
  };

  // const onUserSelectMember = (accountInfo, accountRef, contactRef) => {
  //   devLog("onUserSelectMember", accountRef, contactRef);
  //   setAccountRef(accountRef);
  //   setContactRef(contactRef);
  //   setIsSelectedAccount(accountInfo);
  // const isSelected =
  //   selectedContact !== null &&
  //   (typeof selectedContact === "object" ||
  //     typeof selectedContact === "undefined");
  // setIsSelectedContact(isSelected);
  // devLog("showFooter && isSelectedContact: " + selectedContact);
  // };

  const onUserSelectMember = (memberInfo, selectedContact) => {
    devLog("onUserSelectMember", memberInfo, selectedContact);
    setMemberInfo(memberInfo);
    setSelectedContact(selectedContact);

    // setSelectedContact(selectedContact);
    // const isSelected =
    //   selectedContact !== null &&
    //   (typeof selectedContact === "object" ||
    //     typeof selectedContact === "undefined");
    // setIsSelectedContact(isSelected);
    // devLog("showFooter && isSelectedContact: " + selectedContact);
  };

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("BWC.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <ATTMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
          onMemberInfo={onUserSelectMember}
          onNextClick={onUserNext}
        />
      </div>

      {showFooter && skipMemberSearchLimit > 0 ? (
        <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} />
      ) : (
        <></>
      )}
      {showSelectUserModal && (
        <Dialog
          title={"DriverMissing"}
          message={"ErrorSelectContacts"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowSelectUserModal(false);
          }}
        />
      )}
    </>
  );
}
